import { useMemo, useState } from 'react';
import TextTypography from '../../shared/Typography/Text';
import { checkLeadGurantorsDataForErrors, formateDbGurantors, getUpdatedAllCombinedGuratorData, IGuarantor, ILeadEntity } from '@rasayi-workspace/shared';
import { GuarantorDetailModal } from './guarantorDetailModal';
import { GuarantorEditModal } from './guarantorEditModal';
import { useMutation } from '@tanstack/react-query';
import { updateLead } from 'src/app/services/lead';
import { message } from 'antd';

interface IGuarantorsDetails {
    guarantors: IGuarantor[];
    leadId: string;
    fetchExistingLead: () => void;
}
type UpdateMutation = {
    selectedGuarantor: IGuarantor[];
    updatedGurantor: IGuarantor[];
};
const GuarantorsDetails = ({ guarantors, leadId, fetchExistingLead }: IGuarantorsDetails) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [guarantorShowModal, setGuarantorShowModal] = useState<boolean>(false);
    const [guarantorEditShowModal, setGuarantorEditShowModal] = useState<boolean>(false);
    const [selectedGuarantor, setSelectedGuarantor] = useState<IGuarantor | null>(null);
    const [error, setError] = useState<{ type: 'error' | 'success' | 'info' | 'warning' | ''; message: string }>({ type: '', message: '' });

    const { mutate: updateLeadHandler, isLoading } = useMutation<void, any, UpdateMutation>({
        mutationKey: ['updateLead'],
        mutationFn: async (input: { selectedGuarantor: any; updatedGurantor: any }) => {
            const { selectedGuarantor, updatedGurantor } = input;

            if (selectedGuarantor) {
                const formData = getUpdatedAllCombinedGuratorData(selectedGuarantor, updatedGurantor);
                return updateLead(formData, leadId);
            }

            throw new Error('No selected guarantor provided');
        },
        onSuccess: res => {
            const updatedRes = res as unknown as ILeadEntity;
            const updatedGuarantor = updatedRes.guarantors.find(gu => gu.id === selectedGuarantor?.id);
            if (updatedGuarantor) {
                const gurantors: IGuarantor[] = formateDbGurantors([updatedGuarantor]);
                setSelectedGuarantor(gurantors[0]);
            }
            fetchExistingLead();
            // selectedGuarantor
            messageApi.success('Lead updated successfully!');
        },
        onError: (e: any) => {
            messageApi.error(
                <div>
                    {e?.response?.data?.message?.map((msg: string, index: number) => (
                        <div className="text-start" key={index}>
                            {msg}
                        </div>
                    )) || 'Failed to update lead. Contact support.'}
                </div>
            );
        },
    });

    const guarantorsList = useMemo(() => {
        return guarantors?.map((guarantor, index) => {
            return {
                key: guarantor.id,
                name: (guarantor.first_name ?? '') + ' ' + (guarantor.last_name ?? '') || 'N/A',
                phone: guarantor.primary_mobile ?? 'N/A',
                cnic: guarantor.cnic_number ?? 'N/A',
                id: guarantor.id,
            };
        });
    }, [guarantors]);

    const handleSaveGuarantors = (updatedGurantor: IGuarantor[], selectedGuarantor: IGuarantor[]) => {
        const dataError = checkLeadGurantorsDataForErrors(updatedGurantor);
        setError({ type: dataError ? 'error' : '', message: dataError });

        if (!dataError) {
            if (leadId) {
                !isLoading && updateLeadHandler({ updatedGurantor, selectedGuarantor });
            }
        }
    };

    return (
        <div className=" flex flex-col gap-[20px] cursor-pointer">
            {contextHolder}
            {guarantorsList?.map(guarantor => (
                <div
                    onClick={() => {
                        setGuarantorShowModal(true);
                        setSelectedGuarantor(guarantors.find(gu => gu.id === guarantor.id) || null);
                    }}
                    className="flex justify-between "
                >
                    <TextTypography classNames="font-normal" fontSize={16}>
                        {guarantor.name}
                    </TextTypography>
                    <div className="flex">
                        <TextTypography classNames="font-medium " fontSize={16}>
                            {guarantor.phone}
                        </TextTypography>
                        <div className="w-[1px] h-[70%] bg-[#DBD7D7] mt-[5px] ml-2"></div>
                    </div>
                    <div className="flex">
                        <TextTypography classNames="font-medium " fontSize={16}>
                            {guarantor.cnic}
                        </TextTypography>
                        <div className="w-[1px] h-[70%] bg-[#DBD7D7] mt-[5px] ml-2"></div>
                    </div>
                </div>
            ))}

            {guarantorShowModal && selectedGuarantor ? (
                <GuarantorDetailModal
                    setGuarantorEditShowModal={setGuarantorEditShowModal}
                    guarantor={selectedGuarantor}
                    visible={guarantorShowModal}
                    onClose={() => {
                        setGuarantorShowModal(false);
                        setSelectedGuarantor(null);
                    }}
                />
            ) : null}
            {guarantorShowModal && selectedGuarantor?.id ? (
                <GuarantorEditModal
                    visible={guarantorEditShowModal}
                    leadId={selectedGuarantor.id}
                    onClose={() => {
                        setGuarantorEditShowModal(false);
                    }}
                    onSaveGuarantor={(values: IGuarantor[]) => {
                        if (selectedGuarantor.id) handleSaveGuarantors(values, [selectedGuarantor]);
                    }}
                    initialValue={[selectedGuarantor]}
                    isLoading={isLoading}
                    error={error}
                    setError={setError}
                    exsistingProductLength={1}
                />
            ) : null}
        </div>
    );
};

export default GuarantorsDetails;
